import React from "react";
import styles from "./Payment.module.scss";
import { type PaymentMethod as PaymentMethodType } from "./types";

interface PaymentMethodProps {
  method: PaymentMethodType;
  onClick: (method: string) => void;
  isSelected: boolean;
}

export const PaymentMethod: React.FC<PaymentMethodProps> = ({
  method,
  onClick,
  isSelected,
}) => {
  const Logo = method.logo;

  return (
    <li
      className={`${styles.paymentMethod} ${isSelected ? styles.selectedMethod : ""}`}
      key={method.name}
      onClick={() => onClick(method.method)}
    >
      <div className={styles.paymentIcon}>
        {typeof Logo === "string" ? (
          <img src={Logo} alt={method.name} />
        ) : (
          <Logo />
        )}
      </div>
      <div className={styles.paymentName}>{method.name}</div>
      <div className={styles.paymentFavorite}></div>
    </li>
  );
};
